import React from "react";
import { Loader2 } from "lucide-react";

interface DeleteStreamSettingModalProps {
  isDeleting: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

const DeleteStreamSettingModal: React.FC<DeleteStreamSettingModalProps> = ({
  isDeleting,
  onCancel,
  onDelete,
}) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-2xl w-full max-w-md">
        <h3 className="text-lg font-semibold text-slate-900">
          Delete Stream Setting?
        </h3>
        <p className="text-slate-600 mt-2">
          Are you sure you want to delete this?
        </p>

        <div className="mt-6 flex justify-end gap-4">
          <button onClick={onCancel} className="px-4 py-2 border rounded-xl">
            Cancel
          </button>

          <button
            onClick={onDelete}
            disabled={isDeleting}
            className={`w-24 px-4 py-2 flex items-center justify-center gap-2 rounded-xl text-white transition ${
              isDeleting
                ? "bg-red-400 opacity-70 cursor-not-allowed"
                : "bg-red-600 hover:bg-red-700"
            }`}
          >
            {isDeleting && <Loader2 className="h-4 w-4 animate-spin" />}
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteStreamSettingModal;
